import { Routes } from '@angular/router';
import { LoginComponent } from './shared/user/components/login/login';
import { HomeComponent } from './shared/general/components/home/home';
import { ProfileComponent } from './shared/user/components/profile/profile';
import { CreateUserComponent } from './shared/user/components/create-user/create-user';
import { authGuard } from './core/guards/auth.guard';
import { PropertyListComponent } from './features/property/components/property-list/property-list';
import { CreatePropertyComponent } from './features/property/components/create-property/create-property';
import { NotFoundComponent } from './shared/general/components/not-found/not-found';
import { ForgotPasswordComponent } from './shared/user/components/forgot-password/forgot-password';
import { PropertyEditComponent } from './features/property/components/property-edit/property-edit';
import { propertyOwnerGuard } from './core/guards/property-owner.guard';
import { VerifyUserComponent } from './shared/user/components/verify-user/verify-user';
import { ResetPasswordComponent } from './shared/user/components/reset-password/reset-password';
import { SalesHome } from './features/sales/components/sales-home/sales-home';
import { CommissionCalculator } from './features/sales/components/commission-calculator/commission-calculator';
import { TermsConditionsComponent } from './shared/general/components/terms-conditions/terms-conditions';
import { PrivacyPolicyComponent} from './shared/general/components/privacy-policy/privacy-policy';
import { ManageUserPropertiesComponent } from './shared/user/components/manage-property/manage-user-properties/manage-user-properties';
import { ManageSavedComponent } from './shared/user/components/manage-saved/manage-saved';
import { ContactUsComponent } from './shared/general/components/contact-us/contact-us';
import { FaqComponent } from './shared/general/components/faq/faq';
import { HostingInfo } from './features/sales/components/hosting-info/hosting-info';
import { PropertyView } from './features/property/components/property-view/property-view';
import { CommonForms } from './features/sales/components/common-forms/common-forms/common-forms';
import { UnauthorizedComponent } from './shared/general/components/unauthorized/unauthorized';
import { AdminComponent } from './shared/admin/components/admin/admin';
import { roleGuard } from './core/guards/role.guard';
import { SalesConsultantListingForm } from './features/sales/components/common-forms/sales-consultant-listing-form/sales-consultant-listing-form';
import { SalesTermsForm } from './features/sales/components/common-forms/sales-terms-form/sales-terms-form';
import { SalesDashboard } from './features/sales/components/sales-dashboard/sales-dashboard';
import { SalesAgentSteps } from './features/sales/components/sales-agent-steps/sales-agent-steps';
import { ReturnComponent } from './shared/general/components/return/return';
import { PublishProperty } from './features/property/components/publish-property/publish-property';
import { propertyResolver } from './features/property/resolvers/property.resolver';
import { ReferralHandlerComponent } from './shared/general/components/referral-handler/referral-handler';

export const routes: Routes = [
  { path: '', component: HomeComponent, pathMatch: 'full' },

  { path: 'signup', component: CreateUserComponent },
  { path: 'sales', component: SalesHome },
  { path: 'sales/calculator', component: CommissionCalculator },
  { path: 'sales/steps', component: SalesAgentSteps },
  { path: 'sales/dashboard', component: SalesDashboard, canActivate: [authGuard, roleGuard(['admin', 'sales'])]},
  { path: 'common-forms', component: CommonForms, canActivate: [authGuard] },
  { path: 'host', component: HostingInfo },
  { path: 'faq', component: FaqComponent },
  { path: 'property/create', component: CreatePropertyComponent, canActivate: [authGuard]},
  { path: 'property/publish/:id', component: PublishProperty },
  {
    path: 'property/:id/edit',
    component: PropertyEditComponent,
    canActivate: [authGuard, propertyOwnerGuard]
  },
  { path: 'property', component: PropertyListComponent,
    children:[
      { path: ':id', component: PropertyView,
        resolve: { property: propertyResolver }
      }
    ]
  },
  { path: 'login', component: LoginComponent },
  { path: 'login/verify', component: VerifyUserComponent },
  { path: 'login/reset-password', component: ResetPasswordComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'contact', component: ContactUsComponent },
  { path: 'contact/:formType', component: ContactUsComponent },
  { path: 'refer/:slug', component: ReferralHandlerComponent },
  { path: 'terms', component: TermsConditionsComponent },
  { path: 'privacy', component: PrivacyPolicyComponent },
  {
    path: 'payment/:propertyId',
    loadComponent: () => import('./shared/general/components/checkout/checkout')
      .then(m => m.CheckoutComponent)
  },
  { path: 'return', component: ReturnComponent },

  // Protected profile routes (grouped)
  {
    path: 'profile',
    canActivate: [authGuard],
    children: [
      { path: '', component: ProfileComponent, pathMatch: 'full' },
      { path: 'manage-properties', component: ManageUserPropertiesComponent },
      { path: 'saved', component: ManageSavedComponent },
      { path: 'admin', component: AdminComponent, canActivate: [roleGuard(['admin'])] }
    ]
  },


  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: '**', component: NotFoundComponent }
];
